import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const ProjectBrands = lazy(
  () => import("@/features/projects/project/brands/index.tsx"),
);

export const Route = createFileRoute(
  "/_auth/_app-shell/projects/$projectId/brands",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ProjectBrands />
    </Suspense>
  );
}
